import { useEffect } from 'react';

/**
 * Hook to prevent tab/window close with a confirmation dialog
 * @param shouldPrevent - Boolean indicating whether to show the confirmation
 * @param message - Optional custom message (note: modern browsers show their own message)
 */
export function useConfirmPageUnload(
  shouldPrevent: boolean,
  message = 'Are you sure you want to leave? Your changes may be lost.',
) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldPrevent) {
        // Standard way to trigger browser's confirmation dialog
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
      return undefined;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPrevent, message]);
}
